// Two-line headline, revealed word-by-word.
export const TITLE_LINES: Array<Array<string>> = [
  ["LET’S", "TURN", "YOUR"],
  ["IDEA", "INTO", "IMPACT."],
];

// Rolling marquee tags at the bottom of the section.
export const MARQUEE_TAGS: string[] = [
  "Book a Session",
  "Free 30-min Intro",
  "No Commitment",
  "Let’s Build",
];
